import type {UserDetailSerializer} from "@/generated/DjangoTypes";
import {create} from "@/store/createStore";
import type {TNonFunctionKeys} from "@/store/types";
import {devtools} from "zustand/middleware";
import {immer} from "zustand/middleware/immer";

type TState = {
  user: UserDetailSerializer;
  setValue<K extends TNonFunctionKeys<TState>>(key: K, value: TState[K]): void;
  setUserData(data: TState["user"]): void;
  updateMemberShip(member_until: string): void;
  reset(): void;
};

const initialState = {
  id: 0,
  email: "",
  is_company: false,
  is_influencer: false,
  influencer_uuid: null,
  user_type: "",
  influenced_admin: false,
  interests: [],
  owns_open_campaign: false,
  is_verified: false,
  member_until: null,
  username: null,
  tiktok_username: null,
  currency: "CHF",
  country: null,
  company_uuid: null,
  company: {
    id: 0,
    rating: 0,
    number_of_orders: 0,
    picture: null,
    has_active_campaign: false,
    liked_influencers: [],
    has_campaign: false,
  },
  package_subscription: null,
  aboutme: null,
  address_city: null,
  address_street: null,
  address_street_number: null,
  address_postal: null,
  first_name: "",
  last_name: "",
  phonenumber: null,
  buyouts: [],
  ugc_expert: false,
  agencies: [],
  active_recently: false,
  active_recently_last_two_months: false,
  sub_brands: [],
  tiktok_username_id: null,
  tiktok_verified: false,
  ugc_verified: false,
  username_id: null,
} as Pick<TState["user"], TNonFunctionKeys<TState["user"]>>;

const useUserStore = create<TState>()(
  immer(
    devtools(
      set => ({
        user: initialState,
        setValue: (key, value) =>
          set(
            state => {
              state[key] = value;
            },
            false,
            "userStore/setValue",
          ),
        setUserData: data =>
          set(
            state => {
              if (!data.package_subscription?.package_type) {
                state.user = {...data, package_subscription: null};
              } else {
                state.user = data;
              }
            },
            false,
            "userStore/setUserData",
          ),
        updateMemberShip: member_until =>
          set(
            state => {
              state.user.member_until = member_until;
            },
            false,
            "userStore/updateMemberShip",
          ),
        reset: () =>
          set(
            state => {
              state.user = initialState;
            },
            false,
            "userStore/reset",
          ),
      }),
      {name: "useUserStore"},
    ),
  ),
);

export default useUserStore;
